

























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Tabbar, TabbarItem } from 'vant';
import VoteButton from './VoteButton.vue';
import SuccessModal from './SuccessModal.vue';
Vue.use(Tabbar).use(TabbarItem);

@Component({
  components: {
    VoteButton,
    SuccessModal,
  },
})
export default class BottomTabbar extends Vue {
  @Prop() selectTabNum!: any;
  active: number = 0;
  id = [];
  modalInsufficient = false;
  modalVisible = false;
  target = '';
  voteResponseList: any = null;
  // @Prop() themeColor!: { activeBgColor: string; inactiveBgColor: string };
  themeColor: any = {
    activeBgColor: 'rgb(183, 1, 0)',
    inactiveBgColor: 'rgb(220, 4, 3)',
  };
  tabbarIcons = [
    { img: require('../assets/候选人.png'), tabPath: '/fmxy/first' },
    { img: require('../assets/事迹详情.png'), tabPath: '/fmxy/news' },
  ];
  saveBtn = [{ img: require('../assets/saveTab.png'), tabPath: 'news' }];
  @Watch('$route', {
    immediate: true,
  })
  onRouteChange(to: any) {
    for (let i = 0; i < this.tabbarIcons.length; i++) {
      if (this.tabbarIcons[i].tabPath === to.path) {
        this.active = i;
      }
    }
  }

  @Watch('selectTabNum', {
    immediate: true,
  })
  changeSelectTabNum() {
    if (this.selectTabNum.length) {
      this.id = this.selectTabNum;
    }
  }
  navTo(index: number) {
    // if (index === this.active) {
    //   return location.reload();
    // }
    if (this.tabbarIcons[index].tabPath === this.$route.path) {
      // return location.reload();
    } else {
      this.$router.push(`${this.tabbarIcons[index].tabPath}`);
    }
  }
  onVoteSuccess(payload: any) {
    this.id = [];
    this.$emit('success');
    this.target = 'success';
    this.modalVisible = true;
    this.voteResponseList = payload;
  }
  // 票数不足
  InsufficientVotes(e: Event) {
    if (this.id.length !== 10) {
      e.stopPropagation();
      this.modalInsufficient = true;
      setTimeout(() => {
        this.modalInsufficient = false;
      }, 2000);
    }
    setTimeout(() => {
      this.modalInsufficient = false;
    }, 2000);
  }
  toggleModal() {
    this.modalVisible = false;
  }
}
